export default __webpack_public_path__ + "static/media/coolCar.e24f6ab1.jpg";